module.exports = __webpack_public_path__ + "static/HHub-DiscussionGuide_DownloadPDF-1568f0eea7886f3a351ff506e41b9dbb.pdf";